<ion-radio-group [(ngModel)]="selectedVariation">
  <ion-grid [fixed]="true">
    @if(noVarations()) {
    <ion-row>
      @for(num of [1,2,3,4,5,6,7,8]; track $index) {
      <ion-col size="12" size-md="6">
        <ion-skeleton-text class="fake-variation" [animated]="true"></ion-skeleton-text>
      </ion-col>
      }
    </ion-row>
    } @else {
    <ion-row>
      @for (variation of printVariations(); track variation.id) {
      <ion-col size="12" size-md="6">
        <app-option-selector
          [icon]="variation.icon"
          [name]="variation.name"
          [description]="variation.description"
          [item]="variation"
          [isSelected]="variation == selectedVariation()"
          (click)="onVariationClick(variation)"
          (dblclick)="onDoubleClick()">
        </app-option-selector>
      </ion-col>
      }
    </ion-row>
    }
  </ion-grid>
</ion-radio-group>
